import {OptionLabelValue} from './OptionLabelValue';
import {Sorter} from './tables/sorters';
import {ImportReportParamApi} from '../../redux/api/importReport';

export type ImportReportTableColumns =
  'sigi_code' |
  'country' |
  'admin_level_1' |
  'admin_level_2' |
  'admin_level_3' |
  'address' |
  'operation' |
  'is_resolved';

export type ImportReportErrorTableColumn = ImportReportTableColumns
export type ImportReportWarningTableColumn = ImportReportTableColumns;
export type ImportReportOkTableColumn = Exclude<ImportReportTableColumns, 'is_resolved'>;

export type ImportReportErrorTableSorters = { [K in ImportReportErrorTableColumn]: Sorter }
export type ImportReportWarningTableSorters = { [K in ImportReportWarningTableColumn]: Sorter }
export type ImportReportOkTableSorters = { [K in ImportReportOkTableColumn]: Sorter }

export type ImportReportErrorTableFiltersFE = Partial<Record<ImportReportTableColumns, OptionLabelValue[]>>
export type ImportReportWarningTableFiltersFE = Partial<Record<ImportReportTableColumns, OptionLabelValue[]>>
export type ImportReportOkTableFiltersFE = Partial<Record<Exclude<ImportReportTableColumns, 'is_resolved'>, OptionLabelValue[]>>

export function fromFeToBeImportReportTableFilters(tableFilters: ImportReportErrorTableFiltersFE | ImportReportWarningTableFiltersFE | ImportReportOkTableFiltersFE) {
  let parsedFilters: Partial<ImportReportParamApi> = {}
  for (const [key, value] of Object.entries(tableFilters)) {
      const parsedValue = (value as OptionLabelValue[]).map(el => el.value).join(key === 'address' ? '|' : ',');
      parsedFilters = {...parsedFilters, [key]: parsedValue};
  }
  return parsedFilters;
}